export default __webpack_public_path__ + "static/media/hierarchy.5f973213.svg";